import { Link } from 'react-router-dom';
import { categories } from '@/mocks/navigation';

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-3">
            全部分类导航
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            八大核心分类，覆盖互联网常用场景，快速找到您需要的网站资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 border border-background-200/70 rounded-lg p-6 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-secondary-100 rounded-lg mb-4 group-hover:bg-primary-100 transition-colors">
                <i className={`${cat.icon} text-xl text-secondary-600 group-hover:text-primary-600 transition-colors`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-900 mb-2 whitespace-nowrap">{cat.name}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center text-sm text-primary-600 font-medium whitespace-nowrap">
                浏览导航
                <i className="ri-arrow-right-line ml-1.5 text-xs group-hover:translate-x-1 transition-transform"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}